import { getFormValues } from 'redux-form';
import { get } from 'lodash';

import { NEW_YORK_SIRS_EXPORT_FORM_NAME } from 'Common/FormEnum';
import { NYSirsExportFieldEnum } from 'Common/FieldEnum';

// Report Selectors
export const getNewBedsCode = (state) => {
  const formValues = formValueSelector(state);
  return formValues ? formValues[NYSirsExportFieldEnum.BedsCode] : '';
};
export const getConfigLoading = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.configLoading');
export const getReportHasData = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.reportHasData');
export const getBedsCode = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.bedsCode');
export const getIncludeEligibilityCodeType = (state) =>
  get(
    state,
    'NewYorkSirsExportState.NewYorkSirsExport.includeEligibilityTypeCode'
  );
export const getLoading = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.loading');
export const getErrors = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.error');
export const getAssignedBedsCodes = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.assignedBedsCodes');
export const getUsedFileNames = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExportList.usedFileNames');

// Auto Export Selectors
export const getExportSchedule = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.exportSchedule');
export const getConfigSaved = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.configSaved');
export const getFileName = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.fileName');
export const getEnabled = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.enabled');
export const getSites = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.sites');
export const getExportSites = (state) =>
  get(state, 'NewYorkSirsExportState.NewYorkSirsExport.exportSites');

// Form Values
export const formValueSelector = getFormValues(NEW_YORK_SIRS_EXPORT_FORM_NAME);



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/export/selectors.js